import React from 'react'
import PropTypes from 'prop-types'

const KeyIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.3333 18H15.3333V14.5714H13.1C12.15 16.6457 10.1 18 7.83333 18C4.61667 18 2 15.3086 2 12C2 8.69143 4.61667 6 7.83333 6C10.1 6 12.1417 7.35429 13.1 9.42857H22V14.5714H20.3333V18ZM17 16.2857H18.6667V12.8571H20.3333V11.1429H11.95L11.7583 10.5686C11.175 8.86286 9.59167 7.71429 7.83333 7.71429C5.53333 7.71429 3.66667 9.63429 3.66667 12C3.66667 14.3657 5.53333 16.2857 7.83333 16.2857C9.59167 16.2857 11.175 15.1371 11.7583 13.4314L11.95 12.8571H17V16.2857ZM7.83333 14.5714C6.45833 14.5714 5.33333 13.4143 5.33333 12C5.33333 10.5857 6.45833 9.42857 7.83333 9.42857C9.20833 9.42857 10.3333 10.5857 10.3333 12C10.3333 13.4143 9.20833 14.5714 7.83333 14.5714ZM7.83333 11.1429C7.375 11.1429 7 11.5286 7 12C7 12.4714 7.375 12.8571 7.83333 12.8571C8.29167 12.8571 8.66667 12.4714 8.66667 12C8.66667 11.5286 8.29167 11.1429 7.83333 11.1429Z"
        fill={color}
      />
    </svg>
  )
}

KeyIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(KeyIcon)
